export default "__VITE_ASSET__DW4gahUO__"